/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type InvoiceType = 'Undefined' | 'Invoice' | 'Proformainvoice' | 'Paymenttaxdocument' | 'Paymentdocument';

export const InvoiceType = {
    Undefined: 'Undefined' as InvoiceType,
    Invoice: 'Invoice' as InvoiceType,
    Proformainvoice: 'Proformainvoice' as InvoiceType,
    Paymenttaxdocument: 'Paymenttaxdocument' as InvoiceType,
    Paymentdocument: 'Paymentdocument' as InvoiceType
};